import {
  Component,
  OnInit,
  ViewChild,
  TemplateRef,
  ChangeDetectorRef,
  Output,
  EventEmitter,
} from "@angular/core";
import { BsModalRef, BsModalService } from "ngx-bootstrap";
import { FiltroRicercaAnagrafeVO } from "@app/shared/vo/gescor/filtro-ricerca-anagrafeVO";
import { FiltroSoggettoAnagrafeVO } from "@app/shared/vo/gescor/filtro-soggetto-anagrafeVO";
import { FiltroRecapitoAnagrafeVO } from "@app/shared/vo/gescor/filtro-recapito-anagrafeVO";
import { TipoSoggettoAnagrafeEnum } from "@app/shared/enum/tipo-soggetto-anagrafe-enum";
import { TipoDestinatarioEnum } from "@app/shared/enum/tipo-destinatario-enum";
import { TipoEntitaAnagrafeEnum } from "@app/shared/enum/tipo-entita-anagrafe-enum";
import { TipoRecapitoAnagrafeEnum } from "@app/shared/enum/tipo-recapito-anagrafe-enum";
import { TipoSupportoDocumentoEnum } from "@app/shared/enum/tipo-supporto-documento-enum";
import { TipoRecapitoCartaceoEnum } from "@app/shared/enum/tipo-recapito-cartaceo-enum";
import { TipoRecapitoDigitaleConMailEnum } from "@app/shared/enum/tipo-recapito-digitale-con-mail";
import { TipoDocumentoDigitaleEnum } from "@app/shared/enum/tipo-documento-digitale.enum";
import { TipoRecapitoDigitaleEnum } from "@app/shared/enum/tipo-recapito-digitale-enum";


@Component({
  selector: "app-modale-ricerca-avanzata-anagrafe",
  templateUrl: "./modale-ricerca-avanzata-anagrafe.component.html",
})
export class ModaleRicercaAvanzataAnagrafeComponent implements OnInit {
  @Output()
  public ricercaEmit: EventEmitter<FiltroRicercaAnagrafeVO> = new EventEmitter<
    FiltroRicercaAnagrafeVO
  >();
  @ViewChild("templateRicercaAvanzataAnagrafe", { static: false })
  public ricercaAvanzataModal: TemplateRef<any>;
  public modalRef: BsModalRef;
  private config = {
    class: "modal-dialog modal-info modal-lg",
    animated: true,
  };

  public disabledSelect: boolean = false;
  public disabledIdSoggetto: boolean = false;
  public disabledIdRecapito: boolean = false;
  public disabled: boolean = false;
  public tipoSoggettoAnagrafeEnum = TipoSoggettoAnagrafeEnum;
  public tipoDestinatarioEnum = TipoDestinatarioEnum;
  public tipoEntitaAnagrafeEnum = TipoEntitaAnagrafeEnum;
  public filtroRicercaAnagrafeVO: FiltroRicercaAnagrafeVO = new FiltroRicercaAnagrafeVO();
  public tipoRecapitoEnum: any;
  public tipoRecapitoAnagrafeEnum = TipoRecapitoAnagrafeEnum;
  public tipoRecapitoCartaceoEnum = TipoRecapitoCartaceoEnum;

  constructor(private modalService: BsModalService) { }

  ngOnInit() {
    this.filtroRicercaAnagrafeVO.filtroSoggettoAnagrafeVO = new FiltroSoggettoAnagrafeVO();
    this.filtroRicercaAnagrafeVO.filtroRecapitoAnagrafeVO = new FiltroRecapitoAnagrafeVO();
  }

  openModal(tipoPartenza: TipoSupportoDocumentoEnum) {
    this.modalRef = this.modalService.show(
      this.ricercaAvanzataModal,
      this.config
    );
    if (tipoPartenza === TipoSupportoDocumentoEnum.DIGITALE) {
      this.tipoRecapitoEnum = TipoRecapitoDigitaleEnum;
    } else {
      this.tipoRecapitoEnum = TipoRecapitoCartaceoEnum;
    }
  }

  public resetRicercaAvanzata() {
    this.modalRef.hide();
    this.filtroRicercaAnagrafeVO.filtroSoggettoAnagrafeVO = new FiltroSoggettoAnagrafeVO();
    this.filtroRicercaAnagrafeVO.filtroRecapitoAnagrafeVO = new FiltroRecapitoAnagrafeVO();
    this.disabledIdSoggetto = false;
    this.disabledIdRecapito = false;
    this.disabled = false;
    this.disabledSelect = false;
  }

  public abilitaTastoRicercaSogg(testo: string) {
    if (
      (this.filtroRicercaAnagrafeVO.filtroRecapitoAnagrafeVO.idSoggetto ===
        undefined ||
        this.filtroRicercaAnagrafeVO.filtroRecapitoAnagrafeVO.idSoggetto.toString() ===
        "") &&
      (this.filtroRicercaAnagrafeVO.filtroRecapitoAnagrafeVO.idRecapito ===
        undefined ||
        this.filtroRicercaAnagrafeVO.filtroRecapitoAnagrafeVO.idRecapito.toString() ===
        "")
    ) {
      this.disabled = true;
    }
    if (this.filtroRicercaAnagrafeVO.filtroRecapitoAnagrafeVO.idSoggetto > 0) {
      this.disabled = false;
      this.disabledSelect = true;
      this.disabledIdRecapito = true;
    } else {
      this.disabledSelect = false;
      this.disabledIdRecapito = false;
      switch (
      this.filtroRicercaAnagrafeVO.filtroSoggettoAnagrafeVO.tipoSoggetto
      ) {
        case this.tipoSoggettoAnagrafeEnum.CITTADINO.toString():
          if (
            this.filtroRicercaAnagrafeVO.filtroSoggettoAnagrafeVO.cognome !=
            null ||
            this.filtroRicercaAnagrafeVO.filtroSoggettoAnagrafeVO.nome !=
            null ||
            this.filtroRicercaAnagrafeVO.filtroRecapitoAnagrafeVO
              .tipoRecapito !== "" ||
            this.filtroRicercaAnagrafeVO.filtroSoggettoAnagrafeVO.codice != null
          ) {
            this.disabled = false;
            this.disabledIdSoggetto = true;
            this.disabledIdRecapito = true;
          } else {
            this.disabled = true;
          }
          break;
        case this.tipoSoggettoAnagrafeEnum.AMMINISTRAZIONE.toString():
          if (
            this.filtroRicercaAnagrafeVO.filtroSoggettoAnagrafeVO.nome !=
            null ||
            this.filtroRicercaAnagrafeVO.filtroRecapitoAnagrafeVO
              .tipoRecapito !== "" ||
            this.filtroRicercaAnagrafeVO.filtroSoggettoAnagrafeVO.codice != null
          ) {
            this.disabled = false;
            this.disabledIdSoggetto = true;
            this.disabledIdRecapito = true;
          } else {
            this.disabled = true;
          }
          break;
        case this.tipoSoggettoAnagrafeEnum.AMMINISTRAZIONE_NON_IPA.toString():
          if (
            this.filtroRicercaAnagrafeVO.filtroSoggettoAnagrafeVO.nome !=
            null ||
            this.filtroRicercaAnagrafeVO.filtroRecapitoAnagrafeVO
              .tipoRecapito !== "" ||
            this.filtroRicercaAnagrafeVO.filtroSoggettoAnagrafeVO.codice != null
          ) {
            this.disabled = false;
            this.disabledIdSoggetto = true;
            this.disabledIdRecapito = true;
          } else {
            this.disabled = true;
          }
          break;
        case this.tipoSoggettoAnagrafeEnum.AOO.toString():
          if (
            this.filtroRicercaAnagrafeVO.filtroSoggettoAnagrafeVO.nome !=
            null ||
            this.filtroRicercaAnagrafeVO.filtroRecapitoAnagrafeVO
              .tipoRecapito !== ""
          ) {
            this.disabled = false;
            this.disabledIdSoggetto = true;
            this.disabledIdRecapito = true;
          } else {
            this.disabled = true;
          }
          break;
        case this.tipoSoggettoAnagrafeEnum.ASSOCIAZIONE.toString():
          if (
            this.filtroRicercaAnagrafeVO.filtroSoggettoAnagrafeVO
              .denominazione != null ||
            this.filtroRicercaAnagrafeVO.filtroRecapitoAnagrafeVO
              .tipoRecapito !== "" ||
            this.filtroRicercaAnagrafeVO.filtroSoggettoAnagrafeVO.codice != null
          ) {
            this.disabled = false;
            this.disabledIdSoggetto = true;
            this.disabledIdRecapito = true;
          } else {
            this.disabled = true;
          }
          break;
        case this.tipoSoggettoAnagrafeEnum.IMPRESA.toString():
          if (
            this.filtroRicercaAnagrafeVO.filtroSoggettoAnagrafeVO
              .denominazione != null ||
            this.filtroRicercaAnagrafeVO.filtroRecapitoAnagrafeVO
              .tipoRecapito !== "" ||
            this.filtroRicercaAnagrafeVO.filtroSoggettoAnagrafeVO.codice != null
          ) {
            this.disabled = false;
            this.disabledIdSoggetto = true;
            this.disabledIdRecapito = true;
          } else {
            this.disabled = true;
          }
          break;
        case this.tipoSoggettoAnagrafeEnum.SOGGETTO_STRANIERO.toString():
          if (
            this.filtroRicercaAnagrafeVO.filtroSoggettoAnagrafeVO
              .denominazione != null ||
            this.filtroRicercaAnagrafeVO.filtroRecapitoAnagrafeVO
              .tipoRecapito !== "" ||
            this.filtroRicercaAnagrafeVO.filtroSoggettoAnagrafeVO.codice !=
            null ||
            this.filtroRicercaAnagrafeVO.filtroSoggettoAnagrafeVO.nazione !=
            null
          ) {
            this.disabled = false;
            this.disabledIdSoggetto = true;
            this.disabledIdRecapito = true;
          } else {
            this.disabled = true;
          }
          break;
        case this.tipoSoggettoAnagrafeEnum.UFFICIO.toString():
          if (
            this.filtroRicercaAnagrafeVO.filtroSoggettoAnagrafeVO.nome !=
            null ||
            this.filtroRicercaAnagrafeVO.filtroRecapitoAnagrafeVO
              .tipoRecapito !== ""
          ) {
            this.disabled = false;
            this.disabledIdSoggetto = true;
            this.disabledIdRecapito = true;
          } else {
            this.disabled = true;
          }
          break;
      }
    }
  }

  public abilitaTastoRicercaRecapito(testo: string) {
    if (
      (this.filtroRicercaAnagrafeVO.filtroRecapitoAnagrafeVO.idSoggetto ===
        undefined ||
        this.filtroRicercaAnagrafeVO.filtroRecapitoAnagrafeVO.idSoggetto.toString() ===
        "") &&
      (this.filtroRicercaAnagrafeVO.filtroRecapitoAnagrafeVO.idRecapito ===
        undefined ||
        this.filtroRicercaAnagrafeVO.filtroRecapitoAnagrafeVO.idRecapito.toString() ===
        "")
    ) {
      this.disabled = true;
    }
    if (this.filtroRicercaAnagrafeVO.filtroRecapitoAnagrafeVO.idRecapito > 0) {
      this.disabled = false;
      this.disabledSelect = true;
      this.disabledIdSoggetto = true;
    } else {
      this.disabledSelect = false;
      this.disabledIdSoggetto = false;
      switch (
      this.filtroRicercaAnagrafeVO.filtroRecapitoAnagrafeVO.tipoRecapito
      ) {
        case this.tipoRecapitoAnagrafeEnum.PEC.toString():
          if (
            this.filtroRicercaAnagrafeVO.filtroRecapitoAnagrafeVO
              .indirizzoTelematico != null ||
            this.filtroRicercaAnagrafeVO.filtroSoggettoAnagrafeVO
              .tipoSoggetto !== ""
          ) {
            this.disabled = false;
            this.disabledIdSoggetto = true;
            this.disabledIdRecapito = true;
          } else {
            this.disabled = true;
          }
          break;
        case this.tipoRecapitoAnagrafeEnum.APACI.toString():
          if (
            this.filtroRicercaAnagrafeVO.filtroRecapitoAnagrafeVO
              .indirizzoTelematico != null ||
            this.filtroRicercaAnagrafeVO.filtroSoggettoAnagrafeVO
              .tipoSoggetto !== ""
          ) {
            this.disabled = false;
            this.disabledIdSoggetto = true;
            this.disabledIdRecapito = true;
          } else {
            this.disabled = true;
          }
          break;
        case this.tipoRecapitoAnagrafeEnum.MAIL.toString():
          if (
            this.filtroRicercaAnagrafeVO.filtroRecapitoAnagrafeVO
              .indirizzoTelematico != null ||
            this.filtroRicercaAnagrafeVO.filtroSoggettoAnagrafeVO
              .tipoSoggetto !== ""
          ) {
            this.disabled = false;
            this.disabledIdSoggetto = true;
            this.disabledIdRecapito = true;
          } else {
            this.disabled = true;
          }
          break;
        case this.tipoRecapitoAnagrafeEnum.PORTALE_WEB.toString():
          if (
            this.filtroRicercaAnagrafeVO.filtroRecapitoAnagrafeVO
              .indirizzoTelematico != null ||
            this.filtroRicercaAnagrafeVO.filtroSoggettoAnagrafeVO
              .tipoSoggetto !== ""
          ) {
            this.disabled = false;
            this.disabledIdSoggetto = true;
            this.disabledIdRecapito = true;
          } else {
            this.disabled = true;
          }
          break;
      }
    }
  }

  public onSelectTipo() {
    if (
      this.filtroRicercaAnagrafeVO.filtroSoggettoAnagrafeVO.tipoSoggetto === ""
    ) {
      this.filtroRicercaAnagrafeVO.filtroSoggettoAnagrafeVO = new FiltroSoggettoAnagrafeVO();
    }
    if (
      this.filtroRicercaAnagrafeVO.filtroRecapitoAnagrafeVO.tipoRecapito === ""
    ) {
      this.filtroRicercaAnagrafeVO.filtroRecapitoAnagrafeVO = new FiltroRecapitoAnagrafeVO();
    }

    this.disabled = false;
    this.disabledIdSoggetto = false;
    this.disabledIdRecapito = false;
    this.pulisciCampi();
  }

  public pulisciCampi() {
    this.filtroRicercaAnagrafeVO.filtroSoggettoAnagrafeVO.nome = "";
    this.filtroRicercaAnagrafeVO.filtroSoggettoAnagrafeVO.cognome = "";
    this.filtroRicercaAnagrafeVO.filtroSoggettoAnagrafeVO.codice = "";
    this.filtroRicercaAnagrafeVO.filtroSoggettoAnagrafeVO.cfImpresa = "";
    this.filtroRicercaAnagrafeVO.filtroSoggettoAnagrafeVO.denominazione = "";
    this.filtroRicercaAnagrafeVO.filtroSoggettoAnagrafeVO.nazione = "";

    this.filtroRicercaAnagrafeVO.filtroRecapitoAnagrafeVO.indirizzo = "";
    this.filtroRicercaAnagrafeVO.filtroRecapitoAnagrafeVO.descrizione = "";
    this.filtroRicercaAnagrafeVO.filtroRecapitoAnagrafeVO.dug = "";
    this.filtroRicercaAnagrafeVO.filtroRecapitoAnagrafeVO.numeroCivico = "";
    this.filtroRicercaAnagrafeVO.filtroRecapitoAnagrafeVO.comune = "";
    this.filtroRicercaAnagrafeVO.filtroRecapitoAnagrafeVO.indirizzoTelematico =
      "";
  }

  public emettiFiltroRicerca() {
    console.log("emetto", JSON.stringify(this.filtroRicercaAnagrafeVO));
    this.modalRef.hide();
    this.ricercaEmit.emit(this.filtroRicercaAnagrafeVO);
    this.resetRicercaAvanzata();

  }
}
